import { getMobilePageContract } from "../../mobile/pageTaskContract.ts";
import { resolveMobilePageMode } from "../../util/mobileNavigation.ts";
import { getLeagueChromePolicy } from "./chromePolicy.ts";

type AppShellPolicyInput = {
  inLeague: boolean;
  mobileCoreLoopV4Enabled: boolean;
  mobileIAV3Enabled: boolean;
  pageID: unknown;
};

export const getMobileAppShellPolicy = ({
  inLeague,
  mobileCoreLoopV4Enabled,
  mobileIAV3Enabled,
  pageID,
}: AppShellPolicyInput) => {
  const pageMode = resolveMobilePageMode(pageID);
  const chromePolicy = getLeagueChromePolicy(typeof pageID === "string" ? pageID : undefined);
  // The home page owns the user's next-game card, so a second global score
  // strip would repeat the same matchup. Game-oriented pages keep their own
  // score surfaces rather than mounting this strip through the mobile shell.
  const showScoreStrip = false;
  const mobilePageContract =
    mobileIAV3Enabled && mobileCoreLoopV4Enabled ? getMobilePageContract(pageID) : undefined;
  const useContractShell =
    mobilePageContract && (inLeague || mobilePageContract.shellMode === "outsideLeague");

  if (useContractShell) {
    const contractPageMode = mobilePageContract.shellMode;
    const bottomNav = inLeague && mobilePageContract.bottomNav;

    return {
      bodyBottomChrome: bottomNav,
      chromePolicy,
      pageMode: contractPageMode,
      shellVariant: "mobileContract" as const,
      showAppBar: contractPageMode !== "fullscreen",
      showBottomNavigation: bottomNav,
      showContextHeader:
        mobilePageContract.auditOwner !== "P0C" && contractPageMode !== "fullscreen",
      showPrimaryCTA: false,
      showScoreStrip,
    };
  }

  const standardLeagueShell = inLeague && mobileIAV3Enabled && pageMode === "standard";

  return {
    bodyBottomChrome: standardLeagueShell,
    chromePolicy,
    pageMode,
    shellVariant: "baseline" as const,
    showAppBar: pageMode !== "fullscreen",
    showBottomNavigation: standardLeagueShell,
    showContextHeader: pageMode !== "fullscreen",
    showPrimaryCTA: false,
    showScoreStrip,
  };
};
